import React from 'react';
import { withResolver } from 'components/common';
import { FormGroup } from 'components/common/Forms';
import { compose, withState } from 'recompose';
import { Control } from 'react-redux-form';
import { Card, CardBody } from 'reactstrap';
import { Creatable } from 'react-select';

export const InstallerSurrogateID = ({ surrogate_ids, readOnly}) => (
  <FormGroup>
    <Card>
      <CardBody>
        <FormGroup label="Surrogate ID" >
          <Control.select
            model=".surrogate_ids"
            placeholder="None Set"
            component={Creatable}
            options={surrogate_ids}
            multi
            labelKey="surrogate_id"
            valueKey="surrogate_id"
            disabled={readOnly}
          />
        </FormGroup>
      </CardBody>
    </Card>
  </FormGroup>
);

const enhance = compose(
  withState('surrogate_ids', 'setSurrogate_ids', null),
  withResolver({
      surrogate_ids: () => client => client.get('surrogate_ids'),
  }, {
    onResolved: ({ setSurrogate_ids }) => ({ surrogate_ids }) => {
      setSurrogate_ids(surrogate_ids);
    }
  })
);

export default enhance(InstallerSurrogateID);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerSurrogateID.jsx